import React from "react";
import * as Scrivito from "scrivito";
import { Button } from "components";
import { useTranslate } from "hooks";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { isAnyAccessory } from "utils/treeUtils";

import s from "components/_ProductConfigurator/ProductConfiguratorComponent.module.scss";

export const ProductConfiguratorHeaderButtons = Scrivito.connect(
  ({
    handleAddToProject,
    toggleSpecificationTextModal,
    handleNavigateBackToProject,
  }) => {
    const translate = useTranslate();
    const isUpdating = useProductConfiguratorStore.use.isLoading();
    const productId = useProductConfiguratorStore.use.productId();
    const { kind, projectId } = Scrivito.currentPageParams();

    const isConfiguredAccessory = !!projectId && isAnyAccessory({ kind });

    return !productId ? (
      <div className={s.headerButtons}>
        <Button
          data-testid="product-configurator-header_view-specification-btn"
          color="outline-dark"
          onClick={toggleSpecificationTextModal}
        >
          {translate("PRODUCT_CONFIGURATOR_VIEW_SPECIFICATION")}
        </Button>
        <Button
          data-testid="product-configurator-header_add-to-project-btn"
          color="primary"
          onClick={handleAddToProject}
          disabled={isUpdating}
        >
          {translate("ADD_TO_PROJECT")}
        </Button>
      </div>
    ) : (
      <div className={s.headerButtons}>
        <Button
          data-testid="product-configurator-view-specification-btn-back-to-proj-mode"
          onClick={toggleSpecificationTextModal}
          color="outline-dark"
        >
          {translate("PRODUCT_CONFIGURATOR_VIEW_SPECIFICATION")}
        </Button>
        <Button
          data-testid="product-configurator-header_add-to-other-project-btn"
          color="secondary"
          onClick={handleAddToProject}
          disabled={isUpdating || isConfiguredAccessory}
        >
          {translate("PRODUCT_CONFIGURATOR_ADD_TO_OTHER_PROJECT")}
        </Button>
        <Button
          data-testid="product-configurator-header_back-to-project-structure-btn"
          onClick={handleNavigateBackToProject}
        >
          {translate("PRODUCT_CONFIGURATOR_BACK_TO_PROJECT_STRUCTURE")}
        </Button>
      </div>
    );
  },
);
